import { PaymentPeriod } from "@nf/common";
import { CountryCode } from "@nf/constants";

export const PERIOD_LABEL: Record<PaymentPeriod, string> = {
  [PaymentPeriod.Month]: "web_landing_page_offer_monthly",
  [PaymentPeriod.HalfYear]: "web_subscription_6months",
  [PaymentPeriod.Year]: "web_landing_page_offer_annual",
};

export const ANNUAL_PRICE_DISPLAY: Partial<
  Record<
    CountryCode,
    { divisor: number; period: PaymentPeriod; savingsLabelKey: string }
  >
> = {
  [CountryCode.Finnish]: {
    divisor: 12,
    period: PaymentPeriod.Month,
    savingsLabelKey: "web_signup_annual_in_monthly_price_finland",
  },
};
